import React, { useEffect, useState, ChangeEvent } from "react";
import "./custom-select-styles.scss";

type Props = {
  items: Array<{ id: string | number; keyword: string }>;
  onChange: (value: string | number) => void;
  value: string | number;
  type?: string;
  isLoading?: boolean;
  isWide?: boolean;
  placeholder?: string;
  withSearch?: boolean;
};

const CustomSelectBySources: React.FC<Props> = (props: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchField, setSearchField] = useState<string>("");
  const [items1, setItems1] = useState<
    Array<{ id: string | number; keyword: string }>
  >([...props.items].filter((it: any) => it.id?.toString().slice(-1) == "1"));
  const [items2, setItems2] = useState<
    Array<{ id: string | number; keyword: string }>
  >([...props.items].filter((it: any) => it.id?.toString().slice(-1) == "2"));
  const [items4, setItems4] = useState<
    Array<{ id: string | number; keyword: string }>
  >([...props.items].filter((it: any) => it.id?.toString().slice(-1) == "4"));
  const [items5, setItems5] = useState<
    Array<{ id: string | number; keyword: string }>
  >([...props.items].filter((it: any) => it.id?.toString().slice(-1) == "5"));
  const [items8, setItems8] = useState<
    Array<{ id: string | number; keyword: string }>
  >([...props.items].filter((it: any) => it.id?.toString().slice(-1) == "8"));
  const [items10, setItems10] = useState<
    Array<{ id: string | number; keyword: string }>
  >([...props.items].filter((it: any) => it.id?.toString().slice(-1) == "10"));
  const [items11, setItems11] = useState<
    Array<{ id: string | number; keyword: string }>
  >([...props.items].filter((it: any) => it.id?.toString().slice(-1) == "11"));
  const [items0, setItems0] = useState<
    Array<{ id: string | number; keyword: string }>
  >(
    [...props.items]
      .filter((it: any) => it.id?.toString().slice(-1) != "5")
      .filter((it: any) => it.id?.toString().slice(-1) != "4")
      .filter((it: any) => it.id?.toString().slice(-1) != "2")
      .filter((it: any) => it.id?.toString().slice(-1) != "1")
      ?.filter((it: any) => it.id?.toString().slice(-1) != "8")
      ?.filter((it: any) => it.id?.toString().slice(-1) != "11")
  );

  useEffect(() => {
    const element: any = document.getElementById("custom-select");
    if (isOpen) {
      document.addEventListener("mouseup", function (e) {
        if (!element.contains(e.target)) {
          documentClickListener();
        }
      });
    } else {
      setSearchField("");
      document.removeEventListener("click", documentClickListener);
    }
    return () => document.removeEventListener("click", documentClickListener);
  }, [isOpen]);

  useEffect(() => {
    if (searchField) {
      setItems4(
        [...props.items]
          .filter((it: any) =>
            it.keyword.toLowerCase().includes(searchField.toLowerCase())
          )
          .filter((it: any) => it.id?.toString().slice(-1) == "4")
      );
      setItems1(
        [...props.items]
          .filter((it: any) =>
            it.keyword.toLowerCase().includes(searchField.toLowerCase())
          )
          .filter((it: any) => it.id?.toString().slice(-1) == "1")
      );
      setItems2(
        [...props.items]
          .filter((it: any) =>
            it.keyword.toLowerCase().includes(searchField.toLowerCase())
          )
          .filter((it: any) => it.id?.toString().slice(-1) == "2")
      );
      setItems5(
        [...props.items]
          .filter((it: any) =>
            it.keyword.toLowerCase().includes(searchField.toLowerCase())
          )
          .filter((it: any) => it.id?.toString().slice(-1) == "5")
      );
      setItems8(
        [...props.items]
          .filter((it: any) =>
            it.keyword.toLowerCase().includes(searchField.toLowerCase())
          )
          .filter((it: any) => it.id?.toString().slice(-1) == "8")
      );
      setItems10(
        [...props.items]
          .filter((it: any) =>
            it.keyword.toLowerCase().includes(searchField.toLowerCase())
          )
          .filter((it: any) => it.id?.toString().slice(-1) == "10")
      );
      setItems11(
        [...props.items]
          .filter((it: any) =>
            it.keyword.toLowerCase().includes(searchField.toLowerCase())
          )
          .filter((it: any) => it.id?.toString().slice(-1) == "11")
      );
      setItems0(
        [...props.items]
          .filter((it: any) =>
            it.keyword.toLowerCase().includes(searchField.toLowerCase())
          )
          .filter((it: any) => it.id?.toString().slice(-1) != "4")
          .filter((it: any) => it.id?.toString().slice(-1) != "5")
          .filter((it: any) => it.id?.toString().slice(-1) != "2")
          .filter((it: any) => it.id?.toString().slice(-1) != "1")
          .filter((it: any) => it.id?.toString().slice(-1) != "8")
      );
    } else {
      setItems4(
        [...props.items].filter((it: any) => it.id?.toString().slice(-1) == "4")
      );
      setItems1(
        [...props.items].filter((it: any) => it.id?.toString().slice(-1) == "1")
      );
      setItems2(
        [...props.items].filter((it: any) => it.id?.toString().slice(-1) == "2")
      );
      setItems5(
        [...props.items].filter((it: any) => it.id?.toString().slice(-1) == "5")
      );
      setItems8(
        [...props.items].filter((it: any) => it.id?.toString().slice(-1) == "8")
      );
      setItems10(
        [...props.items].filter(
          (it: any) => it.id?.toString().slice(-1) == "10"
        )
      );
      setItems11(
        [...props.items].filter(
          (it: any) => it.id?.toString().slice(-1) == "11"
        )
      );
      setItems0(
        [...props.items]
          .filter((it: any) => it.id?.toString().slice(-1) != "5")
          .filter((it: any) => it.id?.toString().slice(-1) != "4")
          .filter((it: any) => it.id?.toString().slice(-1) != "2")
          .filter((it: any) => it.id?.toString().slice(-1) != "1")
          .filter((it: any) => it.id?.toString().slice(-1) != "8")
      );
    }
  }, [searchField, props.items]);

  const documentClickListener = (): void => {
    setIsOpen(false);
  };

  const openHandle = (): void => {
    console.log("OPEN", isOpen);
    if (props.items.length > 0) {
      setIsOpen((prevState) => !prevState);
    }
  };

  const changeHandle = (id: string | number): void => {
    props.onChange(id);
    setIsOpen(false);
  };

  const searchHandle = (evt: ChangeEvent<HTMLInputElement>): void => {
    setSearchField(evt.target.value);
  };

  const clearSearch = (): void => {
    setSearchField("");
  };

  return (
    <div
      className={`custom-select${props.type === "interval" ? " interval" : ""}${
        isOpen ? " active" : ""
      }${props.items.length > 0 || props.isLoading ? "" : " disabled"}${
        props.isLoading ? " loading" : ""
      }${props.isWide ? " wide" : ""}`}
      style={{ width: 210 }}
      id={"custom-select"}
    >
      <div className="custom-select__wrap">
        <div className="custom-select__head">
          {props.withSearch && isOpen ? (
            <div
              className="custom-select__search"
              onClick={(event) => event.stopPropagation()}
            >
              <input
                type="text"
                value={searchField}
                onChange={searchHandle}
                placeholder="Найти"
              />
              {searchField.length > 0 ? (
                <span onClick={clearSearch}>×</span>
              ) : null}
            </div>
          ) : (
            <div className="custom-select__current" onClick={openHandle}>
              <span>
                {props.isLoading
                  ? "Загрузка"
                  : props.items.find((it) => it.id === props.value)?.keyword ||
                    props.placeholder ||
                    "Выбор источника"}
              </span>
              <svg viewBox="64 64 896 896" width="12px" height="12px">
                <path d="M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z" />
              </svg>
            </div>
          )}
        </div>
        <div
          className="custom-select-drop"
          onClick={(event) => event.stopPropagation()}
        >
          {props.items?.length > 0 && (
            <div className="custom-select-list">
              <div
                className="custom-select-list__item"
                onClick={() => changeHandle(0)}
              >
                Все
              </div>
              {items4?.length > 0 && (
                <>
                  <p className="custom-select-list__sub-item">СМИ</p>
                  {items4?.map((item) => {
                    return (
                      <div
                        className={`custom-select-list__item${
                          item.id === props.value ? " current" : ""
                        }`}
                        key={item.id}
                        onClick={() => changeHandle(item.id)}
                      >
                        {item.keyword}
                      </div>
                    );
                  })}
                </>
              )}
              {items1?.length > 0 && (
                <>
                  <p className="custom-select-list__sub-item">ВКонтакте</p>
                  {items1?.map((item) => {
                    return (
                      <div
                        className={`custom-select-list__item${
                          item.id === props.value ? " current" : ""
                        }`}
                        key={item.id}
                        onClick={() => changeHandle(item.id)}
                      >
                        {item.keyword}
                      </div>
                    );
                  })}
                </>
              )}
              {items2?.length > 0 && (
                <>
                  <p className="custom-select-list__sub-item">Twitter</p>
                  {items2?.map((item) => {
                    return (
                      <div
                        className={`custom-select-list__item${
                          item.id === props.value ? " current" : ""
                        }`}
                        key={item.id}
                        onClick={() => changeHandle(item.id)}
                      >
                        {item.keyword}
                      </div>
                    );
                  })}
                </>
              )}

              {items5?.length > 0 && (
                <>
                  <p className="custom-select-list__sub-item">Telegram</p>
                  {items5?.map((item) => {
                    return (
                      <div
                        className={`custom-select-list__item${
                          item.id === props.value ? " current" : ""
                        }`}
                        key={item.id}
                        onClick={() => changeHandle(item.id)}
                      >
                        {item.keyword}
                      </div>
                    );
                  })}
                </>
              )}
              {items8?.length > 0 && (
                <>
                  <p className="custom-select-list__sub-item">YouTube</p>
                  {items8?.map((item) => {
                    return (
                      <div
                        className={`custom-select-list__item${
                          item.id === props.value ? " current" : ""
                        }`}
                        key={item.id}
                        onClick={() => changeHandle(item.id)}
                      >
                        {item.keyword}
                      </div>
                    );
                  })}
                </>
              )}
              {items10?.length > 0 && (
                <>
                  <p className="custom-select-list__sub-item">Ok</p>
                  {items10?.map((item) => {
                    return (
                      <div
                        className={`custom-select-list__item${
                          item.id === props.value ? " current" : ""
                        }`}
                        key={item.id}
                        onClick={() => changeHandle(item.id)}
                      >
                        {item.keyword}
                      </div>
                    );
                  })}
                </>
              )}
              {items11?.length > 0 && (
                <>
                  <p className="custom-select-list__sub-item">Дзен</p>
                  {items11?.map((item) => {
                    return (
                      <div
                        className={`custom-select-list__item${
                          item.id === props.value ? " current" : ""
                        }`}
                        key={item.id}
                        onClick={() => changeHandle(item.id)}
                      >
                        {item.keyword}
                      </div>
                    );
                  })}
                </>
              )}
              {items0?.length > 0 && (
                <>
                  <p className="custom-select-list__sub-item">Другое</p>
                  {items0?.map((item) => {
                    return (
                      <div
                        className={`custom-select-list__item${
                          item.id === props.value ? " current" : ""
                        }`}
                        key={item.id}
                        onClick={() => changeHandle(item.id)}
                      >
                        {item.keyword}
                      </div>
                    );
                  })}
                </>
              )}
              {items1.length < 1 &&
              items2.length < 1 &&
              items4.length < 1 &&
              items5.length < 1 &&
              items8.length < 1 &&
              items10.length < 1 &&
              items0.length < 1 &&
              searchField ? (
                <div className="custom-select-list__empty">не найдено</div>
              ) : null}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomSelectBySources;
